import { useEffect, useState } from "react";
import Footer from './components/Footer/Footer';
import ApTopBar from './components/Header/ApTopBar';
import 'bootstrap/dist/css/bootstrap.min.css';
import HeaderBar from "./components/Header/HeaderBar";
import { Routes, Route, useLocation } from "react-router-dom";
import Home from 'components/Home'
import NotFound from "components/NotFound";
import PreviewCart from "components/PreviewCart";
import SignInCallback from "components/SigninCallback";
import SignOutCallback from "components/SignoutCallback";
import SyncCart from "components/SyncCart";
import { useTranslations } from "contexts/TranslationProvider";
import './App.css';
import { useAuth } from "contexts/AuthProvider";
import Order from "components/Order";
import Cart from "components/Cart";
import ReactGA from 'react-ga4';

function App() {
  const location = useLocation();
  const [gaInit, setGaInit] = useState(false);
  const { setCurrentLocale } = useTranslations();
  const { authenticating, isAuthenticated, getUserLanguage, logIn } = useAuth();

  useEffect(() => {
    if (!authenticating && isAuthenticated()) {
      setCurrentLocale(getUserLanguage() || navigator.language);
      console.log(`Set current locale to: ${getUserLanguage() || navigator.language}`);
    }
  }, [authenticating]);

  useEffect(() => {
    ReactGA.initialize(import.meta.env.VITE_GOOGLE_ANALYTICS_TRACKING_ID as string);
    setGaInit(true);
  }, []);

  useEffect(() => {
    gaInit && ReactGA.send({ hitType: "pageview", page: `onlineshop${location.pathname + location.search}` });
  }, [gaInit, location]);

  const ExternalRedirect = ({ url }: { url: string }) => {
    useEffect(() => {
      window.location.replace(url);
    }, [url]);

    return null;
  };

  const LoginRedirect = () => {
    useEffect(() => {
      logIn();
    }, [logIn]);

    return null;
  };

  return (
    <>
      <ApTopBar />
      <HeaderBar />
      <div className="main-container">
        <main>
          <Routes>
            <Route path="/order/signin-oidc/" element={<SignInCallback />} />
            <Route path="/order/signout-oidc/" element={<SignOutCallback />} />
            <Route path='/order/apdorder' element={
              <ExternalRedirect url={import.meta.env.VITE_APDIRECT_ORDER_CART_URL as string} />
            } />
            <Route path='/order/logout' element={
              <ExternalRedirect url={`${import.meta.env.VITE_GATEKEEPER_LOGOUT_URL}?ReturnUrl=${encodeURIComponent(import.meta.env.VITE_MYAP_ORDER_SITE_URL as string)}`} />
            } />
            <Route path='/order/login' element={<LoginRedirect />} />
            <Route path="/order/cart/sync/" element={<SyncCart />} />
            <Route path="/order/cart/" element={<Cart />} />
            <Route path="/:region/:country/:locale/order/preview" element={<PreviewCart />} />
            <Route path="/:region/:country/:locale/order/" element={<Order />} />
            <Route path="/home" element={<Home />} />
            <Route path="/" element={<Home />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
      </div>
      <Footer />
    </>
  );
}

export default App;
